import { services } from '@broadleaf/admin-components';
import ExternalLinkColumn from "./ExternalLinkColumn";

const { ComponentRegistrar } = services;

ComponentRegistrar.registerColumnComponent('LINK', ExternalLinkColumn);
